import { render, staticRenderFns } from "./ModalCreateOrUpdateSubLearningOutcome.vue?vue&type=template&id=5cd1c4a2&"
import script from "./ModalCreateOrUpdateSubLearningOutcome.vue?vue&type=script&lang=js&"
export * from "./ModalCreateOrUpdateSubLearningOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports